import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageCompetitions,
  PageCompetition,
  PageCompetitionPreview,
} from '../pages/competitions';

const RouteCompetitions = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageCompetitions />
      </Route>
      <Route path={`${path}/:_id/preview`}>
        <PageCompetitionPreview />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageCompetition />
      </Route>
    </Switch>
  );
};

export default RouteCompetitions;
